import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/shared/services';
import { Router, ActivatedRoute } from '@angular/router';
import { EventEmitterService } from 'src/app/shared/services';
import { Subscription } from 'rxjs';
import { IOrderAmount } from '../../../shared/models';
import { DatePipe } from '@angular/common';
import { NgxMasonryComponent } from 'ngx-masonry';

@Component({
    selector: 'app-order-success',
    templateUrl: './order-success.component.html',
    styleUrls: ['./order-success.component.less'],
    providers: [DatePipe]
})
export class OrderSuccessComponent implements OnInit {
    cartProducts = [];
    deliveryData: any = [];
    cardDetails: any = [];
    cartProductsLength: number;
    subTotalAmount: number;
    totalShippingCharge = 0;
    totalAmount: number;
    perItemShippingCharge = 25;
    orderDate;
    orderId;
    routeSubscription: any;
    password: string;
    showError: boolean;
    isLoggedIn: boolean;
    showSuccess: boolean;
    eventSubscription: Subscription;
    orderAmount: IOrderAmount;
    isLoading: boolean;
    spinner = 'assets/image/spinner.gif';
    promoDetails: any = {};
    numberOfProducts = 0;
    lastuserId: any;
    @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;
    userType: any;
    isHandset: boolean;
    walletDetails: any;


    constructor(
        private apiService: ApiService,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private eventEmitterService: EventEmitterService,
        private datePipe: DatePipe
    ) {
    }

    ngOnInit() {
    this.userType = JSON.parse(localStorage.getItem("user"))?.authorization;
    this.isHandset = window.innerWidth <= 768 ? true : false;

        this.isLoading = true;
        this.routeSubscription = this.activeRoute.params.subscribe(
            (routeParams) => {
                this.orderId = routeParams.order;
            }
        );
        this.eventSubscription = this.eventEmitterService.userChangeEvent
            .asObservable()
            .subscribe((user) => {
                if (this.lastuserId !== user.id) {
                    this.lastuserId = user.id;
                    this.isLoggedIn = user.authorization === 1;
                    this.apiService.getOrderSuccessData(this.orderId).subscribe(
                        (payload: any) => {
                            payload.cart.products.forEach((product: any) => {
                                  product['canSeeDesignPricing'] = ((''+this.userType)=='2' ||(''+this.userType)=='70' ||(''+this.userType)=='90') &&  
                                   (+product.inventory?.inventory_product_details?.design_price) >0;
                                   product['designPrice'] = +product.inventory?.inventory_product_details?.design_price || 0;
                            });


                            this.cartProducts = payload.cart.products;
                            this.orderAmount = payload.cart.order;
                            this.deliveryData = payload.delivery;
                            this.cardDetails = payload.payment[0];
                            this.walletDetails = payload.wallet_payment;
                            this.orderDate = this.datePipe.transform(payload.payment[0].date, 'd MMM, yyyy');
                            // this.orderDate = moment(payload.delivery[0].created_at).format(
                            //     'D MMM, YYYY'
                            // );
                            this.promoDetails = payload.cart.promo_details;
                            this.numberOfProducts = this.cartProducts.reduce((acc, product) => acc += product.count, 0);
                            this.isLoading = false;
                            setTimeout(() => {
                                if (this.masonry !== undefined) {
                                    this.masonry.reloadItems();
                                    this.masonry.layout();
                                }
                            }, 1000);
                        },
                        (error: any) => {
                            this.isLoading = false;
                        }
                    );
                }
            });
    }

    onDestroy(): void {
        this.eventSubscription.unsubscribe();
    }

    updatePassword() {
        if (this.password && this.password.length < 8) {
            this.showError = true;
        } else {
            this.showError = false;
            // const localUser: any = JSON.parse(localStorage.getItem('user') || '{}');
            const registeredEmail = localStorage.getItem('registeredEmail') || '';
            const registeredName = localStorage.getItem('registeredName') || '';
            const data = {
                name: registeredName,
                email: registeredEmail,
                password: this.password
            };
            this.apiService.userUpdate(data).subscribe(
                (payload: any) => {
                    localStorage.setItem('user', JSON.stringify(payload.success.user));
                    this.showSuccess = true;
                    const self = this;
                    setTimeout(() => {
                        self.isLoggedIn = true;
                    }, 1000);
                },
                (error: any) => {
                }
            );
        }
    }

    renderText(text: string): string {
        const htmlComponent = document.createElement('textarea');
        htmlComponent.innerHTML = text;
        return htmlComponent.value;
    }

setImgHeight(item: any, img: HTMLImageElement) {
  item.imgHeight ='150px'// img.clientWidth; // store per item
}



}
